// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".group-multiselect{width:100%;margin-right:0}", "",{"version":3,"sources":["webpack://./apps/settings/src/components/AdminDelegation/GroupSelect.vue"],"names":[],"mappings":"AACA,mBACC,UAAA,CACA,cAAA","sourcesContent":["\n.group-multiselect {\n\twidth: 100%;\n\tmargin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
